export const scrollToSection = (sectionId, { behavior = 'smooth', updateHash = true } = {}) => {
  const element = document.getElementById(sectionId);
  if (!element) return false;

  const lenis = typeof window !== 'undefined' ? window.__lenis : undefined;

  if (lenis && behavior === 'smooth') {
    // équivaut au scroll-margin-top: 5.5rem des sections (non géré par Lenis)
    lenis.scrollTo(element, { offset: -88 });
  } else {
    element.scrollIntoView({ behavior, block: 'start' });
  }

  if (updateHash) {
    window.history.pushState(null, '', `#${sectionId}`);
  }

  return true;
};
